import { Component, inject } from '@angular/core'
import { ZardDialogRef, Z_MODAL_DATA } from '@/styles/components/dialog'
import { ZardButtonComponent } from '@/styles/components/button'
import { ZardIconComponent } from '@/styles/components/icon/icon.component'
import { ISuccessDialogData } from '../../models/dialog.models'
import { DEFAULT_DIALOG_TEXTS } from '../../../core/constants/button-text.constants'

@Component({
    selector: 'app-success-dialog',
    templateUrl: './success-dialog.component.html',
    styleUrls: ['./success-dialog.component.scss'],
    imports: [ZardButtonComponent, ZardIconComponent],
})
export class SuccessDialogComponent {
    dialogRef = inject<ZardDialogRef<SuccessDialogComponent>>(ZardDialogRef)
    data = inject<ISuccessDialogData>(Z_MODAL_DATA)

    defaultTexts = DEFAULT_DIALOG_TEXTS

    handleConfirmClick(): void {
        this.dialogRef.close(true)
    }

    handleViewClick(): void {
        this.dialogRef.close('view')
    }

    handleCloseClick(): void {
        this.dialogRef.close()
    }
}
